import { useState } from 'react';
import { get, isEmpty, set } from 'lodash';
import { commonPath } from '../fieldPath';
import { checkArray } from '../../../../Components/helper';

export default function useValidationHooks(productCostingstate) {
  const [globalError, setGlobalErrors] = useState({});

  const validateFields = {
    productInfo: ['supplierId', 'currency', 'incoterms'],
    averageCosting: ['quantityPerSizCol'],
    bomDataError: ['quantityUnitOfMeasure'],
    testing: ['colourway'],
    quantities: ['quantityPerSizCol'],
    productTemplate: ['productTemplate'],
    costingTemplate: ['costingTemplate'],
  };

  const thisFieldisRequired = 'This field is required';

  const checkValidation = (isColourHidden) => {
    const fieldError = globalError;
    const copyState = productCostingstate;
    const { isBreakdown } = productCostingstate;
    let hasErrors = false;
    if (isColourHidden) {
      validateFields.testing = [];
    }
    Object.keys(validateFields)?.forEach((key) => {
      switch (key) {
        case 'productInfo': {
          const productInfoData = get(copyState, commonPath().PRODUCT_INFO);
          validateFields[key].forEach((fieldKey) => {
            if (!productInfoData[fieldKey]) {
              hasErrors = true;
              set(fieldError, `[${key}][${fieldKey}]`, thisFieldisRequired);
            } else set(fieldError, `[${key}][${fieldKey}]`, '');
          });
          break;
        }
        case 'testing': {
          const testingData = copyState.testing.testingInfo || [];
          testingData.forEach((element, index) => {
            validateFields[key].forEach((fieldKey) => {
              if (!element[fieldKey]) {
                hasErrors = true;
                set(fieldError, `[${key}][${index}][${fieldKey}]`, thisFieldisRequired);
              } else set(fieldError, `[${key}][${index}][${fieldKey}]`, '');
            });
          });
          break;
        }
        case 'additional': {
          const additionalData = copyState.additional.additionalInfo || [];
          additionalData &&
            additionalData.length > 0 &&
            additionalData.forEach((element, index) => {
              validateFields[key].forEach((fieldKey) => {
                if (!element[fieldKey] || (typeof element[fieldKey] === 'object' && Object.keys(element[fieldKey]).length === 0)) {
                  hasErrors = true;
                  set(fieldError, `[${key}][${index}][${fieldKey}]`, thisFieldisRequired);
                } else set(fieldError, `[${key}][${index}][${fieldKey}]`, '');
              });
            });
          break;
        }
        case 'averageCosting': {
          const data = copyState.averageCosting.averageCostingInfo || [];
          data &&
            data?.length > 0 &&
            data?.forEach((ele, index) => {
              if (ele?.expandData && ele?.expandData?.length) {
                ele?.expandData?.forEach((element, chindex) => {
                  validateFields[key]?.forEach((fieldKey) => {
                    if (isBreakdown && chindex === 0) {
                      if (!element[fieldKey] || (typeof element[fieldKey] === 'object' && Object.keys(element[fieldKey]).length === 0)) {
                        hasErrors = true;
                        set(fieldError, `[${key}][${index}][${chindex}][${fieldKey}]`, thisFieldisRequired);
                      } else set(fieldError, `[${key}][${index}][${chindex}][${fieldKey}]`, '');
                    } else if (!isBreakdown) {
                      if (!element[fieldKey] || (typeof element[fieldKey] === 'object' && Object.keys(element[fieldKey]).length === 0)) {
                        console.log('does not have breakdown', element[fieldKey]);
                        hasErrors = true;
                        set(fieldError, `[${key}][${index}][${chindex}][${fieldKey}]`, thisFieldisRequired);
                      } else set(fieldError, `[${key}][${index}][${chindex}][${fieldKey}]`, '');
                    }
                  });
                });
              }
            });
          break;
        }
        case 'quantities': {
          const quantitiesData = copyState?.quantities?.quantitiesInfo || [];
          checkArray(quantitiesData) &&
            quantitiesData?.forEach((ele, index) => {
              if (ele?.expandData && ele?.expandData?.length) {
                ele?.expandData?.forEach((element, chindex) => {
                  validateFields[key].forEach((fieldKey) => {
                    if (isBreakdown && chindex === 0) {
                      if (!element[fieldKey] || (typeof element[fieldKey] === 'object' && Object.keys(element[fieldKey]).length === 0)) {
                        hasErrors = true;
                        set(fieldError, `[${key}][${index}][${chindex}][${fieldKey}]`, thisFieldisRequired);
                      } else set(fieldError, `[${key}][${index}][${chindex}][${fieldKey}]`, '');
                    } else if (!isBreakdown) {
                      if (!element[fieldKey] || (typeof element[fieldKey] === 'object' && Object.keys(element[fieldKey]).length === 0)) {
                        console.log('quantities==========');
                        hasErrors = true;
                        set(fieldError, `[${key}][${index}][${chindex}][${fieldKey}]`, thisFieldisRequired);
                      } else set(fieldError, `[${key}][${index}][${chindex}][${fieldKey}]`, '');
                    }
                  });
                });
              }
            });
          break;
        }
        case 'detailedCosting': {
          const detailedCostData = copyState?.detailedCosting?.bomTypeArr || [];
          detailedCostData?.forEach((element, index) => {
            if (!element[validateFields?.bomDataError[0]]) {
              hasErrors = true;
              set(fieldError, `bomDataError[${index}][${validateFields?.bomDataError[0]}]`, thisFieldisRequired);
            } else set(fieldError, `bomDataError[${index}][${validateFields?.bomDataError[0]}]`, '');
            const detailedCostingInfo = element?.detailedCostingInfo;
            detailedCostingInfo?.forEach((info, chIndex) => {
              const { expandData } = info;
              expandData?.forEach((expData, expIndex) => {
                validateFields[key]?.forEach((fieldKey) => {
                  if (isBreakdown && expIndex === 0) {
                    if (!expData[fieldKey] || (typeof expData[fieldKey] === 'object' && Object.keys(expData[fieldKey]).length === 0)) {
                      hasErrors = true;
                      set(fieldError, `[${key}][${index}][${chIndex}][${expIndex}][${fieldKey}]`, thisFieldisRequired);
                    } else set(fieldError, `[${key}][${index}][${chIndex}][${expIndex}][${fieldKey}]`, '');
                  } else if (!isBreakdown) {
                    if (!expData[fieldKey] || (typeof expData[fieldKey] === 'object' && Object.keys(expData[fieldKey]).length === 0)) {
                      console.log('detailedCosting==========');
                      hasErrors = true;
                      set(fieldError, `[${key}][${index}][${chIndex}][${expIndex}][${fieldKey}]`, thisFieldisRequired);
                    } else set(fieldError, `[${key}][${index}][${chIndex}][${expIndex}][${fieldKey}]`, '');
                  }
                });
              });
            });
          });
          break;
        }
        case 'landedInfo': {
          const landedData = copyState?.landedInfo?.landedInfoArr || [];
          landedData?.forEach((element, index) => {
            validateFields[key].forEach((fieldKey) => {
              if (!element[fieldKey] || (typeof element[fieldKey] === 'object' && Object.keys(element[fieldKey]).length === 0)) {
                hasErrors = true;
                set(fieldError, `[${key}][${index}][${fieldKey}]`, thisFieldisRequired);
              } else set(fieldError, `[${key}][${index}][${fieldKey}]`, '');
            });
            element?.landedInfoRowArr.forEach((childEle, chInde) => {
              validateFields.landedChild.forEach((chFieldKey) => {
                if (!childEle[chFieldKey]) {
                  hasErrors = true;
                  set(fieldError, `[${key}][${index}][${chInde}][${chFieldKey}]`, thisFieldisRequired);
                } else set(fieldError, `[${key}][${index}][${chInde}][${chFieldKey}]`, '');
              });
            });
          });
          break;
        }
        case 'productTemplate': {
          const selectedTemplate = copyState.productTemplate;
          if (isEmpty(selectedTemplate)) {
            hasErrors = true;
            fieldError.productTemplate = 'Select Template';
          } else {
            fieldError.productTemplate = '';
          }
          break;
        }
        case 'costingTemplate': {
          const selectedCosting = copyState.costingTemplate;
          if (isEmpty(selectedCosting)) {
            hasErrors = true;
            fieldError.costingTemplate = 'Select Costing Stage';
          } else {
            fieldError.costingTemplate = '';
          }
          break;
        }
        default:
          break;
      }
    });
    setGlobalErrors((err) => ({ ...err, ...fieldError }));
    return hasErrors;
  };

  const onChangeCheckIfErrorExist = (path, errorsData) => {
    const error = errorsData;
    set(error, path, '');
    setGlobalErrors((err) => ({ ...err, ...error }));
  };

  return {
    checkValidation,
    setGlobalErrors,
    globalError,
    onChangeCheckIfErrorExist,
  };
}
